import { apiClient } from './apiClient';

export type Company = {
  id: string;
  name: string;
  legalName?: string | null;
  document?: string | null;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  notes?: string | null;
  ownerUserId?: string | null;
  ownerUserName?: string | null;
  isActive: boolean;
  createdAtUtc: string;
  updatedAtUtc: string;
};

export type CompanyListResult = {
  items: Company[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export type CompanyUpsertPayload = {
  name: string;
  legalName?: string;
  document?: string;
  email?: string;
  phone?: string;
  website?: string;
  notes?: string;
  ownerUserId?: string;
  isActive?: boolean;
};

export async function listCompanies(
  params: { activeOnly?: boolean; search?: string; page?: number; pageSize?: number } = {},
): Promise<CompanyListResult> {
  const response = await apiClient.get<CompanyListResult>('/v1/core/companies', { params });
  return response.data;
}

export async function createCompany(payload: CompanyUpsertPayload): Promise<Company> {
  const response = await apiClient.post<Company>('/v1/core/companies', payload);
  return response.data;
}

export async function updateCompany(id: string, payload: CompanyUpsertPayload): Promise<Company> {
  const response = await apiClient.put<Company>(`/v1/core/companies/${id}`, payload);
  return response.data;
}

export async function deleteCompany(id: string): Promise<void> {
  await apiClient.delete(`/v1/core/companies/${id}`);
}
